const THROTTLE_RE = /throttl|rate.?limit|too.?many/i;
const TIMEOUT_RE = /timeout|timed?\s*out/i;
const REDIS_RE = /redis|connection.*refused/i;
const DOCUMENT_RE = /s3|preprocess|document/i;
const MODEL_RE = /bedrock|InvokeModel|model.*error/i;

interface ErrorPattern {
  match: (details: string) => boolean;
  userMessage: string;
}

const ERROR_PATTERNS: ErrorPattern[] = [
  {
    match: (d) => THROTTLE_RE.test(d),
    userMessage: "The AI service is busy. Please wait a moment and try again.",
  },
  {
    match: (d) => TIMEOUT_RE.test(d),
    userMessage: "The request timed out. Please try again.",
  },
  {
    match: (d) => REDIS_RE.test(d),
    userMessage: "A temporary service issue occurred. Please try again.",
  },
  {
    match: (d) => DOCUMENT_RE.test(d),
    userMessage:
      "There was a problem processing your document. Please re-upload and try again.",
  },
  {
    match: (d) => MODEL_RE.test(d),
    userMessage: "The AI model is temporarily unavailable. Please try again.",
  },
];

export function getUserErrorMessage(details: string): string {
  for (const pattern of ERROR_PATTERNS) {
    if (pattern.match(details)) {
      return pattern.userMessage;
    }
  }
  return "Something went wrong. Please try again.";
}
